import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';
import {
  publishEvent,
  SupervisorHangupResult,
} from '@salesforce/scv-connector-base';
import type { PhoneCall } from '@salesforce/scv-connector-base';
import { Constants } from '@salesforce/scv-connector-base';
import type { SupervisorDisconnectEventPublisher } from './supervisor-disconnect.usecase';

export class SupervisorDisconnectPublisher
  implements SupervisorDisconnectEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(
    call: PhoneCall,
    callId: string,
    agentNumber: string,
  ): Promise<void> {
    const busIframe = await BusIframe.getIframe();
    const busEvent: BusEvent = {
      type: 'DIALER.HANGUP',
    };

    this.logger.info('Publisher: Supervisor listen in', {
      action: 'supervisorListen',
      callId,
      agentNumber,
    });

    publishEvent({
      eventType: Constants.VOICE_EVENT_TYPE.SUPERVISOR_HANGUP,
      payload: new SupervisorHangupResult({ calls: call }),
      registerLog: true,
    });

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
